module.exports = __webpack_public_path__ + "static/media/icon-clock.c324d311.svg";